import {
  PaymentSettingV2,
  ProcedureDetailType,
  Template,
  ApplicantSchemaKeys,
} from "./procedure-detail";
import { AuthLevelCorporation, AuthLevelIndividual } from "./procedure-entity";

export class RequireAuthLevel {
  requireAuthLevel: {
    corporation: AuthLevelCorporation;
    individual: AuthLevelIndividual;
  };

  constructor(values: Pick<ProcedureDetailType, "requireAuthLevel">) {
    this.requireAuthLevel = values.requireAuthLevel;
  }
}

export class PublishedProcedureDetail {
  template: Template;
  acceptAnyFile: boolean;
  paymentSetting?: PaymentSettingV2;
  requireAuthLevel: {
    corporation: AuthLevelCorporation;
    individual: AuthLevelIndividual;
  };
  applicantSchemaKeys: ApplicantSchemaKeys;

  constructor(values: ProcedureDetailType) {
    this.template = values.template;
    this.acceptAnyFile = values.acceptAnyFile;
    this.paymentSetting = values.paymentSetting;
    this.requireAuthLevel = values.requireAuthLevel;
    this.applicantSchemaKeys = values.applicantSchemaKeys;
  }
}
